import { successNotification } from "@app/common/components/notifications";
import { useAuthentication } from "@app/store/useAuthtentication";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  downloadSupportConsultExcel,
  handleUpdateSupportFileService,
  supportConsultListService,
  consumerOutReportsService,
  supportDetailDispensaryService,
  updateSupportFileService,
  downloadConsumerOutReportsExcel
} from "./supportsConsult";
import type { IConsumerOutReportFilters, SupportConsultFilter, UpdSupportFile } from "./types";

export function useGetSupportConsultList(filters: SupportConsultFilter, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    enabled,
    gcTime: 0,
    queryKey: ["supportConsult", filters.page, filters.perpage],
    queryFn: async () => await supportConsultListService(filters, token)
  });

  return query;
}

export function useGetConsumerOutReports(filters: IConsumerOutReportFilters, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    enabled,
    gcTime: 0,
    queryKey: ["consumerOutReports", filters.page, filters.perpage, filters.trigger],
    queryFn: async () => await consumerOutReportsService(filters, token)
  });

  return query;
}

export function useGetSupportDetailDispensary(
  filters: { id: number; trigger: number },
  enabled = true
) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    enabled,
    gcTime: 0,
    queryKey: ["supportParams", filters.id, filters.trigger],
    queryFn: async () => await supportDetailDispensaryService(filters, token)
  });

  return query;
}

export function useUpdateSupportFile(onSuccess = async () => {}) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);
  const mutation = useMutation({
    mutationFn: async (payload: UpdSupportFile) =>
      (await payload.id)
        ? handleUpdateSupportFileService(payload, token)
        : updateSupportFileService(payload, token),
    onSuccess: async (data) => {
      successNotification(data.message, "Actualizado exitosamente");
      await onSuccess();
    }
  });

  return mutation;
}

export const useDownloadConsumerOutReportExcel = (filters: IConsumerOutReportFilters) => {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled: false,
    gcTime: 0,
    queryKey: ["consumerOutReportExcel", filters],
    queryFn: async () => await downloadConsumerOutReportsExcel(filters, token)
  });
};

export const useDownloadSupportConsultExcel = (filters: SupportConsultFilter) => {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled: false,
    gcTime: 0,
    queryKey: ["supportConsultExcel", filters],
    queryFn: async () => await downloadSupportConsultExcel(filters, token)
  });
};
